import { createFileRoute } from '@tanstack/react-router'

import { ServicePerformanceScreen } from './-components/service-performance-screen.tsx'

export const Route = createFileRoute('/engineering/service-performance')({
  component: ServicePerformanceScreen
})
